import React, { ReactNode } from 'react';
import { ContentTemplate, Typography } from 'web-library';
import { Theme } from '@mui/material';


import { makeStyles } from 'tss-react/mui';

// TODO jss-to-tss-react codemod: usages of this hook outside of this file will not be converted.
export const useStyles = makeStyles()((theme) =>
({
  marginBottom4: {
    marginBottom: theme.spacing(4),
  },
  errorText: {
    color: theme.color.state.stateError,
    marginTop: theme.spacing(4),
  },
}));

interface RankingDetailsProps {
  sectionHeader: string;
  rankingTable: ReactNode;
}

const RankingDetails = ({ sectionHeader, rankingTable }: RankingDetailsProps) => {
  const { classes } = useStyles();

  return (
    <ContentTemplate isDividerTop type="full">
      <Typography variant="h3" className={classes.marginBottom4}>
        {sectionHeader}
      </Typography>
      {rankingTable}
    </ContentTemplate>
  );
};

export default RankingDetails;
